import React, {useState} from 'react';
import {BoxStyled} from "../../../styled/FAQ";
import { FaAngleUp, FaAngleDown } from "react-icons/fa";
import {useTheme} from "../Theme/ThemeContext";


const Item = ({ content }) => {
    const [open, setOpen] = useState(false);
    const {themeName} = useTheme();

    return (
        <BoxStyled theme={themeName}>
            <button onClick={()=> setOpen(!open)} className="question">
                <p>{content.q}</p>
                <span>
                    {open ? <FaAngleDown /> : <FaAngleUp />}
                </span>
            </button>
            {open && <p className={`answer${open ? ' BubblePopIn' : ''}`}>{content.a}</p>}

        </BoxStyled>

    );
}

export default Item;